import { HStack, NavigationBar, VStack } from '@direct-frontend/components';
import { Outlet } from '@direct-frontend/modules-router';
import { useToggle } from '@direct-frontend/stdlib';
import { CompanyLogo } from '#shared/components/CompanyLogo';
import { useMobileView } from '#shared/lib/platform';
import { useThemeColor } from '#shared/lib/theme';
import { AppShellProvider } from '#widgets/AppShellProvider';
import { PreviewSidePanel } from '#widgets/PreviewSidePanel';
import { getMenuSections } from '../DashboardLayout';
import { DashboardSidebar } from '../DashboardLayout/DashboardSidebar';
import ApplicationLayoutDesktop from './ApplicationLayout@desktop';
import { YcpServiceAlert } from './YcpServiceAlert';
import styles from './ApplicationLayout@mobile.module.css';

export default function ApplicationLayout() {
    const showMobileView = useMobileView();
    const { value: isSidebarOpen, toggleOn: openSidebar, toggleOff: closeSidebar } = useToggle(false);
    const themeColor = useThemeColor();

    if (!showMobileView) {
        return <ApplicationLayoutDesktop />;
    }

    return (
        <AppShellProvider>
            <VStack className={styles.root}>
                <YcpServiceAlert />
                <DashboardSidebar
                    menuSections={getMenuSections()}
                    onToggleIsOpen={(value: boolean) => {
                        if (value) {
                            openSidebar();
                        } else {
                            closeSidebar();
                        }
                    }}
                    isOpen={isSidebarOpen}
                />
                <NavigationBar
                    logo={
                        <HStack className={styles.logo}>
                            <CompanyLogo width={151} height={28} alt="Логотип" theme={themeColor} />
                        </HStack>
                    }
                    onMenuClick={openSidebar}
                />
                <Outlet />
                <PreviewSidePanel />
            </VStack>
        </AppShellProvider>
    );
}
